import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
//nonssr
// import { CookieService } from "ngx-cookie";
import { BehaviorSubject } from "rxjs";
import { RootService } from "../auth/root.service";
import { secureStorage } from "../encryption/securestorage";
import { BehaviorDataService } from "./behavior-data.service";
import { CookieService } from "./cookie.service";

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  userdetails: any;
  usertoken: any;
  user_code: any;
  public loginStatus: BehaviorSubject<boolean>;

  constructor(
    private snackBar: MatSnackBar,
    private behaviorService: BehaviorDataService,
    private rootService: RootService,
    private router: Router,
    private localStorage: secureStorage,
  //  private cookieService: CookieService,
   private ssrcookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object,) {}

  afterLogin(response: any, loginScreen: any) {
    let data = response.data;
    let tokendetails = response.data.token;
    this.userdetails = {
      keycloak_user_id: data.keycloak_user_id,
      email_id: data.email_id,
      first_name: data.first_name,
      middle_name: data.middle_name,
      last_name: data.last_name,
      phone_number: data.phone_number,
      is_email_exist  :data.is_email_exist,
      userid: data.id
    }
    this.usertoken = {
      access_token: tokendetails.access_token,
      expires_in: tokendetails.expires_in,
      refresh_token: tokendetails.refresh_token,
      refresh_expires_in: tokendetails.refresh_expires_in,
    }
    this.user_code = {
      user_code: data.user_code,
      isLoggedIn: loginScreen
    }
    // return () => {
       this.rootService.setToken(this.usertoken);
    this.rootService.setUserCode(this.user_code);
    if (loginScreen) {
      this.rootService.setUserData(this.userdetails)
      this.router.navigateByUrl('/dashboard')

      this.behaviorService.isLoggedIn.next(true);

    }
    // dealer_location_id: null
    //
    // is_active: true
    // parent: null
    // party_sub_type: "Seller"
    // party_type: "Seller"
    // user_name: "8097310188"
  }

  // Every cookie this app puts on the browser. Naming only access_token /
  // ref_token / isuserLoggedIn used to leave the free-search pair behind, so a
  // logged-out browser still carried half a session.
  private static readonly SESSION_COOKIES = [
    'isuserLoggedIn',
    'access_token',
    'ref_token',
    'free_access_token',
    'free_ref_token',
  ];

  // `userInitiated` means the person actually pressed Yes on the logout
  // prompt, and everything the site stored goes -- analytics ids included.
  // The interceptor also calls logout() on its own to recover from a
  // half-expired session (http.interceptor.ts:194), and that fires on ordinary
  // page loads; those must only drop this app's own session cookies, or a
  // routine reload silently resets the visitor's analytics and consent state.
  logout(userInitiated = false) {
    if (userInitiated) {
      this.ssrcookieService.removeAll();
    } else {
      SharedService.SESSION_COOKIES.forEach((name) =>
        this.ssrcookieService.removeItem(name)
      );
    }
    // The session itself is held in HttpOnly cookies by the site's server
    // (bff.ts); the removeItem calls above cannot reach those.
    this.rootService.endServerSession();
    this.behaviorService.isLoggedIn.next(false);
    this.behaviorService.userLoggedOut.next(true);

    // Deliberately not secureStorage.clear(): that helper also fires
    // navigateByUrl('') + window.location.reload(), and the reload cancelled
    // the caller's own redirect, dumping the user back on the page they were
    // logging out from. Callers decide where to go next.
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  /**
   * Copies text to the clipboard, and answers whether it worked.
   *
   * `navigator.clipboard` only exists in a SECURE context -- https, or
   * localhost. It is absent over plain http, which is exactly how the site is
   * reached when testing on a phone against `ng serve --host 0.0.0.0`
   * (http://<lan-ip>:4200) or any non-TLS staging host. Callers that reached
   * for it directly silently did nothing there, which is why the FAQ page's
   * "Number Copied" never appeared on a phone.
   *
   * The fallback is the pre-clipboard-API approach: a throwaway off-screen
   * textarea, selected, with document.execCommand('copy') over it. Deprecated,
   * but it is what works without TLS and every mobile browser still honours it.
   */
  copyText(value: string): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    if (navigator.clipboard && window.isSecureContext) {
      // Fire-and-forget: the promise resolves after this returns, and a
      // rejection is handled by the same textarea fallback below on the next
      // press. Reporting success here keeps callers synchronous.
      navigator.clipboard.writeText(value).catch(() => this.copyViaTextarea(value));
      return true;
    }

    return this.copyViaTextarea(value);
  }

  private copyViaTextarea(value: string): boolean {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    // Off-screen but still focusable/selectable; `position: fixed` avoids the
    // page jumping to it the way an absolutely positioned node would.
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    // iOS Safari refuses to select a readonly=false field it considers
    // unfocusable, and zooms into anything with a font-size under 16px.
    textarea.setAttribute('readonly', '');
    textarea.style.fontSize = '16px';
    document.body.appendChild(textarea);

    try {
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, value.length);
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }

  // Bottom-right, per the comp. Below md the card widens to the screen and
  // reads as bottom-centre instead -- see the toast block at the end of
  // src/styles.scss, which is also where both panelClass hooks are styled.
  //
  // Browser only. A snackbar raised during SSR is rendered into the HTML the
  // server sends, so it arrives already on screen for EVERY visitor and never
  // dismisses -- its 5s timer ran server-side and died with the render. That
  // is what put a permanent "Something went wrong, Please try again !" on
  // /dashboard: the server renders that page without a session, its vehicle
  // list call fails there, and the resulting toast was baked into the page.
  // A toast is a response to something the reader just did; there is no reader
  // during a render.
  failedSnackBarResponse(msg: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.snackBar.open(msg, '', {
      duration: 5000,
      panelClass: ["custom-styleRed"], verticalPosition: "bottom", // Allowed values are  'top' | 'bottom'
      horizontalPosition: "right" // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
    });
  }

  successSnackBarResponse(msg: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.snackBar.open(msg, '', {
      duration: 5000,
      panelClass: ["custom-style"], verticalPosition: "bottom", // Allowed values are  'top' | 'bottom'
      horizontalPosition: "right" // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
    });
  }

  getOwners(d:any){
    if (d > 3 && d < 21) return d + "th";
    switch (d % 10) {
      case 1:  return d + "st";
      case 2:  return d + "nd";
      case 3:  return d + "rd";
      default: return d + "th";
    }
  }
}
